import React from "react";
import { Clipboard } from "@capacitor/clipboard";

interface ProductDetailItemProps {
  label: string;
  value: string | number | null | undefined;
  unit?: string;
  canCopyValue?: boolean;
}

const ProductDetailItem: React.FC<ProductDetailItemProps> = ({ label, value, unit, canCopyValue }) => {
  const valueStr = value != null ? String(value).trim() : "";
  const shouldAppendUnit = Boolean(unit && valueStr && !valueStr.toLowerCase().endsWith(unit.toLowerCase()));
  const displayValue = valueStr ? `${valueStr}${shouldAppendUnit ? ` ${unit}` : ""}` : "Н/Д";

  const handleCopy = async () => {
    if (canCopyValue && valueStr) {
      await Clipboard.write({
        string: displayValue,
      });
    }
  };

  return (
    <div className="flex flex-col">
      <div className="text-[#A6A6A6]">{label}</div>
      <div onClick={handleCopy}>{displayValue}</div>
    </div>
  );
};

export default ProductDetailItem;
